import React, {Component} from 'react';
import { Link, Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './Header';


const	Dashboard = ( ) => {
	return (
		<>
		<Header />
		<Box
        component="main"
        sx={{
          mt: { xs: 7, sm: 8 }, // Responsive margin for AppBar height
          p: 3, // Consistent padding
          height: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 64px)' },
          overflow: 'auto'
        }}
      >
        <Outlet />  
      </Box>
      
		</>
	)
}
export default Dashboard;
//     render(){
// 
//         return (
// 				<div class="m-content">				
// 			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
//        				<div class="m-grid__item m-grid__item--fluid m-wrapper">
// 					<div class="m-subheader ">					
// 						<div class="d-flex align-items-center">
// 							<div class="mr-auto">
// 								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle CORE</h3>
// 								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
// 									<li class="m-nav__item m-nav__item--home">
// 										<a href="index.html" class="m-nav__link m-nav__link--icon">
// 											<i class="m-nav__link-icon la la-home"></i>
// 										</a>
// 									</li>
// 									<li class="m-nav__separator">-</li>
// 									<li class="m-nav__item">
// 										<a href="index.html" class="m-nav__link">
// 											<span class="m-nav__link-text">Home</span>
// 										</a>
// 									</li>
// 								</ul>
// 							</div>
// 							<div>
// 								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
// 									<span class="m-subheader__daterange-label">
// 										<span class="m-subheader__daterange-title"></span>
// 										<span class="m-subheader__daterange-date m--font-brand"></span>
// 									</span>
// 									<a href="index.html" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
// 										<i class="la la-angle-down"></i>
// 									</a>
// 								</span>
// 							</div>
// 						</div>
// 						<br />
// 
// 					<div className="content-wrapper">
// 						<div class="m-portlet">
// 							<div class="m-portlet__body  m-portlet__body--no-padding">
// 								<div class="row m-row--no-padding m-row--col-separator-xl">
// 									<div class="col-xl-6">
// 										<div class="m-widget14">
// 											<iframe width="600" height="400" src="https://live.amcharts.com/jljYj/embed/" frameborder="0"></iframe>
// 										</div>
// 									</div>
// 									<div class="col-xl-6">
// 										<div class="m-widget14">
// 											<iframe width="600" height="400" src="https://live.amcharts.com/NDQ4O/embed/" frameborder="0"></iframe>										
// 										</div>
// 									</div>
// 								</div>
// 							</div>
// 						</div>
// 
// 					<div className="content-wrapper">
// 						<div class="m-portlet">
// 							<div class="m-portlet__body  m-portlet__body--no-padding">
// 								<div class="row m-row--no-padding m-row--col-separator-xl">
// 									<div class="col-xl-6">
// 										<div class="m-widget14">
// 											<iframe width="600" height="400" src="https://live.amcharts.com/mZTNl/embed/" frameborder="0"></iframe>
// 										</div>
// 									</div>
// 									<div class="col-xl-6">
// 										<div class="m-widget14">
// 											<iframe width="600" height="400" src="https://live.amcharts.com/AwYWQ/embed/" frameborder="0"></iframe>
// 										</div>
// 									</div>
// 								</div>
// 							</div>
// 						</div>            
// 					</div>		
// 
// 					<hr />
// 
// 					<div className="content-wrapper">
// 						<div class="m-portlet">
// 							<div class="m-portlet__body  m-portlet__body--no-padding">
// 								<div class="row m-row--no-padding m-row--col-separator-xl">
// 									<div class="col-xl-6">
// 										<div class="m-widget14">
// 											<iframe width="600" height="400" src="https://live.amcharts.com/hlY2U/embed/" frameborder="0"></iframe>
// 										</div>
// 									</div>
// 									<div class="col-xl-6">
// 									<h3>Customer Experience Index</h3>				
// 										<div class="m-widget14">
// 											<iframe width="600" height="400" src="https://live.amcharts.com/NDQ4O/embed/" frameborder="0"></iframe>										
// 										</div>
// 									</div>
// 								</div>
// 							</div>
// 						</div>            
// 					</div>		
// 
// 					<hr />
// 
// 					<div className="content-wrapper">
// 						<div class="m-portlet">
// 							<div class="m-portlet__body  m-portlet__body--no-padding">
// 								<div class="row m-row--no-padding m-row--col-separator-xl">
// 									<div class="col-xl-6">
// 										<div class="m-widget14">
// 											<iframe width="600" height="400" src="https://live.amcharts.com/2YTRh/embed/" frameborder="0"></iframe>
// 										</div>
// 									</div>
// 									<div class="col-xl-6">
// 										<div class="m-widget14">
// 											<iframe width="600" height="400" src="https://live.amcharts.com/Dg1Nm/embed/" frameborder="0"></iframe>
// 										</div>
// 									</div>
// 								</div>
// 							</div>
// 						</div>            
// 					</div>	
// 					
// 					<hr />
// 
// 					<div className="content-wrapper">
// 						<div class="m-portlet">
// 							<div class="m-portlet__body  m-portlet__body--no-padding">
// 								<div class="row m-row--no-padding m-row--col-separator-xl">
// 									<div class="col-xl-6">
// 									<h3>Expired Loyalty Dollars</h3>				
// 										<div class="m-widget14">
// 											<iframe width="600" height="400" src="https://live.amcharts.com/jljYj/embed/" frameborder="0"></iframe>
// 										</div>
// 									</div>
// 									<div class="col-xl-6">
// 									<h3>Rewards Spending Index</h3>				
// 										<div class="m-widget14">
// 											<iframe width="600" height="400" src="https://live.amcharts.com/NDQ4O/embed/" frameborder="0"></iframe>										
// 										</div>
// 									</div>
// 								</div>
// 							</div>
// 						</div>            
// 					</div>	            
// 
// 
// 
// 
// 					</div>		
// 
// 	            </div>	
//             </div>
//             
// 			</div>
// 			</div>
// 			)
// 		}
// 	}